define.alias("shared/utils/string-formatters/camel-to-snake", "preview-grid/utils/string-formatters/camel-to-snake");